<template>
	<a-form-item :label="label" :label-col="{ span: labelWidth }" :wrapper-col="{ span: valueWidth }">
		<slot></slot>
	</a-form-item>
</template>
<script>
import { mapState } from 'vuex'
export default {
	props: ['label'],
	data() {
		return {

		}
	},
	computed: {
		...mapState(['settings']),
		labelWidth() {
			if ( this.settings['isMobileView'] ) return 24
			if ( this.settings['isTabletView'] ) return 8
			return 5
		},
		valueWidth() {
			if ( this.settings['isMobileView'] ) return 24
			return 24-this.labelWidth
		}
	},
}
</script>